import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";
import Tooltip from "@mui/material/Tooltip";
import Colors from "../../../assets/styles/Colors";

function MenuButton({ item, open, expired }) {
  const navigate = useNavigate();
  const location = useLocation();
  const active = item.route === `${location.pathname}`;

  const button = (
    <ListItemButton
      key={item.title}
      onClick={() => !expired && navigate(item.route)}
      className={active ? "isActive" : ""}
      sx={{
        minHeight: 42,
        justifyContent: open ? "initial" : "center",
        px: open ? 1.5 : 1,
        mx: open ? 0.5 : 0.25,
        my: 0.35,
        borderRadius: 2,
        opacity: expired ? 0.38 : 1,
        pointerEvents: expired ? "none" : "auto",
        border: active
          ? `1px solid rgba(151, 71, 255, 0.38)`
          : "1px solid transparent",
        backgroundColor: active ? "rgba(151, 71, 255, 0.14)" : "transparent",
        color: active ? Colors.white : Colors.textSecondary,
        transition: "background-color 160ms ease, border-color 160ms ease, color 160ms ease",
        "&:hover": {
          backgroundColor: active ? "rgba(151, 71, 255, 0.18)" : "rgba(255,255,255,0.055)",
          color: Colors.white,
        },
      }}
    >
      {item.icon && (
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 1.5 : "auto",
            justifyContent: "center",
            color: active ? Colors.primaryLight : "currentColor",
            fontSize: 20,
          }}
        >
          {item.icon}
        </ListItemIcon>
      )}
      <ListItemText
        primary={item.title}
        sx={{ opacity: open ? 1 : 0, minWidth: 0, m: 0 }}
        primaryTypographyProps={{
          noWrap: true,
          sx: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: 13,
            fontWeight: active ? 800 : 600,
            letterSpacing: 0.1,
          },
        }}
      />
    </ListItemButton>
  );

  if (expired) {
    return (
      <Tooltip title="Pago vencido — contactá a soporte" placement="right" arrow>
        <span style={{ display: "block" }}>{button}</span>
      </Tooltip>
    );
  }

  return button;
}

export default MenuButton;
